/**
 * Dos triggers: 
 * 1. cartUpdate (se suscribe a un evento del propio tema pubsub y así se dispara siempre al añadir producto
 * 2. requestIdleCallback, si lo soporta el navegador, para que lo haga cuando el navegador tenga tiempo libre. 
 *    2.1 Hay un fallback a setTimeout para navegadores sin soporte, que encola la función tras el evento actual, pero es muy raro
 *
 * Marcador localStorage como cartToken:uid: re-sincroniza solo si rota el uid o si Shopify crea carrito nuevo tras pedido.
 * GDPR implícito: adstax_uid solo existe si el script de adstax corrió con consentimiento (mismo criterio que kevel.js).
 */

(() => {
  const SYNC_KEY = 'adstax_cart_sync';

  const getCookie = (name) =>
    document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]+)`))?.[1] ?? null;

  const syncAdstaxUid = (cartToken = getCookie('cart')) => {
    const uid = getCookie('adstax_uid');
    if (!uid) { localStorage.removeItem(SYNC_KEY); return; }
    if (!cartToken) return;

    const marker = `${cartToken}:${uid}`;
    if (localStorage.getItem(SYNC_KEY) === marker) return;

    const writeUidToCartAttribute = fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { adstax_uid: uid } }),
    });

    writeUidToCartAttribute
      .then((r) => { if (r.ok) localStorage.setItem(SYNC_KEY, marker); })
      .catch(() => {});
  };

  subscribe(PUB_SUB_EVENTS.cartUpdate, ({ cartData } = {}) => syncAdstaxUid(cartData?.token));

  ('requestIdleCallback' in window ? requestIdleCallback : setTimeout)(syncAdstaxUid);
})();